import React, { useState, useId, useEffect } from "react";

export default function CustomSelect({
  options,
  value,
  onChange,
  placeholder,
  required = false,
  error,
  bgColor,
  translations = {},
  name,
  id,
}) {
  const [isFocused, setIsFocused] = useState(false);
  const autoId = useId();
  const inputId = id || autoId;
  const inputName = name || inputId;

  return (
    <div className="relative">
      <select
        // value={value}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        name={inputName}
        id={inputId}
        aria-invalid={error ? "true" : "false"}
        aria-describedby={error ? `${autoId}-error` : undefined}
        className={`h-52 pl-12 pr-10 text-xxs font-medium leading-115 tracking-05 text-gray-700 block w-full rounded-xxxs text-gray-9900 ring-1 ring-inset ring-gray-500 focus:outline-none focus-visible:outline-none bg-transparent`}
      >
        <option disabled value="">
          {placeholder}
        </option>
        {options.length > 0 &&
          options.map((option, index) => (
            <option key={index} value={option}>
              {translations[option] || option}
            </option>
          ))}
      </select>
      <label
        htmlFor={inputId}
        className={`absolute left-12 h-24 pointer-events-none text-xxs font-medium leading-115 tracking-05 text-gray-700 duration-100 ${bgColor} origin-top-left ${
          options.length > 0 && (isFocused || value)
            ? "-top-8 scale-90"
            : "top-18 right-32"
        }`}
        // aria-hidden="true"
      >
        {placeholder}
        {required && <span className="text-red-500"> *</span>}
      </label>
      {error && <span className="block small text-red-500 mt-4">{error}</span>}
    </div>
  );
}
